import { z } from 'zod'

/** Job periódico que observa a sessão do WhatsApp sem enviar mensagens. */
export const FILA_MONITOR_WAHA = 'dv-monitor-waha'

/**
 * O WAHA acrescenta campos entre versões; o DigitalView só depende destes três.
 * `status` é conjunto aberto de propósito: estado novo precisa degradar a saúde,
 * não derrubar o parser e esconder a indisponibilidade.
 */
export const sessaoWaha = z
  .object({
    name: z.string().trim().min(1),
    status: z.string().trim().min(1),
    engine: z.object({ engine: z.string().trim().min(1) }).optional(),
  })
  .loose()

export type SessaoWaha = z.infer<typeof sessaoWaha>
